/**
 * quill-table-up uses ES2022/ES2023 APIs missing in older WebViews (e.g. WeChat).
 * Load before Quill / quill-table-up.
 */
if (typeof Object.hasOwn !== 'function') {
  Object.hasOwn = (obj: object, prop: PropertyKey) =>
    Object.prototype.hasOwnProperty.call(obj, prop);
}

interface ArrayEs2023Polyfills {
  toSorted?<T>(compareFn?: (a: T, b: T) => number): T[];
  toReversed?<T>(): T[];
}

const arrayProto = Array.prototype as typeof Array.prototype & ArrayEs2023Polyfills;

if (typeof arrayProto.toSorted !== 'function') {
  arrayProto.toSorted = function <T>(
    this: T[],
    compareFn?: (a: T, b: T) => number
  ): T[] {
    return [...this].sort(compareFn);
  };
}

if (typeof arrayProto.toReversed !== 'function') {
  arrayProto.toReversed = function <T>(this: T[]): T[] {
    return [...this].reverse();
  };
}

export {};
